import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'formControlErrorMessagesOnSubmit',
  pure: false,
})
export class FormControlErrorMessagesOnSubmitPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(
    formControl: AbstractControl,
    customPatternMsg: string | null,
    submittedForm: boolean | undefined
  ): string {
    let isRequired: any;
    if (formControl.validator) {
      isRequired = formControl.validator({} as AbstractControl);
    }

    const showError = submittedForm || formControl.touched || formControl.dirty;

    if (showError && !formControl.value && isRequired) {
      return 'This field is required';
    } else if (showError && formControl.errors?.['minlength']) {
      return 'Minimum of ' + formControl.errors?.minlength.requiredLength + ' characters';
    } else if (showError && formControl.errors?.['maxlength']) {
      return 'Maximum of ' + formControl.errors?.maxlength.requiredLength + ' characters';
    } else if (showError && formControl.errors?.['mustMatch']) {
      if (formControl.parent?.get('confirmPassword') === formControl) {
        return this.translate.instant(
          'ERROR.passwords_do_not_match'
        );
      } else if (formControl.parent?.get('password_confirmation') === formControl) {
        return this.translate.instant(
          'ERROR.passwords_do_not_match'
        );
      }
      return this.translate.instant('ERROR.fields_do_not_match');
    } else if (
      showError &&
      customPatternMsg &&
      formControl.errors?.['pattern']
    ) {
      return customPatternMsg;
    } else {
      return '';
    }
  }
}
